import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import './config/advanced-commerce.cms-config';
import { AdvancedCommerceRecommendationsEngine } from './recommendations/advanced-commerce-recommendations.engine';
import { AdvancedCommerceTrackClickDirective } from './track/advanced-commerce-track-click.directive';
import { AdvancedCommerceTrackService, initAdvancedCommerceTrackService } from './track/advanced-commerce-track.service';

export function provideDfModuleAdvancedCommerce(): EnvironmentProviders {
    surviveTreeShaking(AdvancedCommerceRecommendationsEngine);

    return makeEnvironmentProviders([
        AdvancedCommerceTrackClickDirective,
        {
            provide: APP_INITIALIZER,
            useFactory: initAdvancedCommerceTrackService,
            deps: [AdvancedCommerceTrackService],
            multi: true
        }
    ]);
}
